export function handleResponse(response) {
    if (response.ok)
        return response.json();

    if (response.status === 401) {
        var returnUrl = window.location.href;

        window.location.href = `/user/login?returnUrl=${returnUrl}`;
        return Promise.reject("Unauthorized");
    }

    if (response.status === 404)
        return response.json()
            .then(error => {
                throw new Error(error.Message);
            });

    throw new Error(response.statusText);
}